import React from "react";
import "./about.css";
import AboutMe from "../../assets/me-about.png";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";
import {RiSpaceShipLine} from 'react-icons/ri'

const About = () => {
  return (
    <section id="about" className='section-style'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={AboutMe} alt="about image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>10+ years</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clients</h5>
              <small>20+</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>15+</small>
            </article>

            <article className="about__card">
              <RiSpaceShipLine className="about__icon" />
              <h5>Startups</h5>
              <small>3</small>
            </article>
          </div>

          <p>
              With over 10 years of experience, I specialize in building responsive web applications using React, Next.js, and TypeScript. Over the past five years, I’ve worked closely with startup founders and C-suite executives to develop innovative products, improve user experiences, and boost performance. My diverse skill set allows me to communicate effectively with teams and stakeholders, ensuring successful project outcomes. Passionate about continuous learning, I thrive in dynamic environments where I can contribute to impactful digital solutions. As a front-end developer, I have a proven track record of delivering high-quality work on time. My strong performance and organizational impact have led to three promotions within two years. I am an ambitious, positive, and reliable team player who is dedicated to serving and collaborating with my colleagues to achieve the best results.
          </p>

        </div>
      </div>
    </section>
  );
};

export default About;
